<template>
  <v-dialog :value="value" max-width="420" @input="$emit('input', $event)">
    <v-card>
      <div class="dlg-head">
        <div class="dlg-head-icon"><v-icon color="#fff">mdi-file-excel-outline</v-icon></div>
        <div>
          <div class="dlg-title">Export to Excel / CSV</div>
          <div class="dlg-sub">Choose the columns to include</div>
        </div>
        <v-spacer />
        <v-btn icon small class="dlg-close" @click="$emit('input', false)"><v-icon>mdi-close</v-icon></v-btn>
      </div>

      <v-card-text class="pt-4">
        <div class="d-flex align-center mb-2">
          <span class="cell-muted">{{ selected.length }} of {{ columns.length }} columns selected</span>
          <v-spacer />
          <v-btn text x-small color="#1565c0" @click="selectAll">Select all</v-btn>
          <v-btn text x-small color="#8a94a6" @click="selected = []">Clear</v-btn>
        </div>
        <v-divider class="mb-1" />
        <div class="export-col-list">
          <v-checkbox
            v-for="col in columns"
            :key="col.value"
            v-model="selected"
            :value="col.value"
            :label="col.text"
            dense
            hide-details
            class="export-col-check"
          />
        </div>
      </v-card-text>

      <v-card-actions class="dlg-actions">
        <v-spacer />
        <v-btn text @click="$emit('input', false)">Cancel</v-btn>
        <v-btn color="#2e7d32" dark :disabled="!selected.length" @click="doExport">
          <v-icon left small>mdi-download-outline</v-icon>
          Download CSV
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'ExportDialog',
  props: {
    value: { type: Boolean, default: false },
    columns: { type: Array, default: () => [] }, // [{ text, value }]
  },
  data() {
    return { selected: [] };
  },
  watch: {
    value(open) {
      if (open) this.selected = this.columns.map((c) => c.value);
    },
  },
  methods: {
    selectAll() {
      this.selected = this.columns.map((c) => c.value);
    },
    doExport() {
      const cols = this.columns.filter((c) => this.selected.includes(c.value));
      this.$emit('export', cols);
      this.$emit('input', false);
    },
  },
};
</script>

<style scoped>
.export-col-list {
  max-height: 300px;
  overflow-y: auto;
}
.export-col-check {
  margin-top: 2px;
}
.export-col-check >>> .v-label {
  font-size: .85rem;
  color: #26314a;
}
</style>
